import React from 'react';
import PropTypes from 'prop-types';
import BigCalendar from 'react-big-calendar';
import moment from 'moment-timezone';
import DateUtils from '../../../lib/utils/date';

// remember the browser's local timezone, as it might by used later on
BigCalendar.tz = moment.tz.guess();
// format all dates in BigCalendar as they would be rendered
// in browser's local timezone (even if later on they won't)
// eslint-disable-next-line no-underscore-dangle
const _m = (...args) => moment.tz(...args, BigCalendar.tz);
_m.localeData = moment.localeData;

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(_m));

const BigCalendarInTimeZone = ({
  events,
  onSelectSlot,
  onEventDrop,
  timeZone,
  ...props
}) => {
  const convertDateTimeToDate = (datetime, allDay, tz, dateType) => {
    const m = DateUtils.isoStringToMoment(datetime, allDay, tz);
    // Adds extra day since BigCalendar allDay rendering
    // is not inclusive of end date
    if (allDay && dateType === 'end') m.add(1, 'day');
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0);
  };

  const convertDateToDateTime = date => {
    const dateM = moment.tz(date, BigCalendar.tz);
    const m = moment.tz(
      {
        year: dateM.year(),
        month: dateM.month(),
        date: dateM.date(),
        hour: dateM.hour(),
        minute: dateM.minute()
      },
      BigCalendar.tz
    );
    return m;
  };
  const bigCalendarProps = {
    ...props,
    events: events.map(event => ({
      ...event,
      start: convertDateTimeToDate(event.start, event.allDay, timeZone),
      end: convertDateTimeToDate(event.end, event.allDay, timeZone, 'end')
    })),
    onSelectSlot:
      onSelectSlot &&
      (({ start, end, slots }) => {
        onSelectSlot({
          start: convertDateToDateTime(start, timeZone),
          end: convertDateToDateTime(end, timeZone),
          slots: slots.map(date => convertDateToDateTime(date, timeZone))
        });
      }),
    onEventDrop:
      onEventDrop &&
      // eslint-disable-next-line react/prop-types
      (({ event, start, end }) => {
        onEventDrop({
          event,
          start: convertDateToDateTime(start, timeZone),
          end: convertDateToDateTime(end, timeZone)
        });
      })
  };
  return <BigCalendar {...bigCalendarProps} />;
};

BigCalendarInTimeZone.propTypes = {
  events: PropTypes.array.isRequired,
  onSelectSlot: PropTypes.func,
  onEventDrop: PropTypes.func,
  timeZone: PropTypes.string
};

export default BigCalendarInTimeZone;



// WEBPACK FOOTER //
// ./webpack/components/Modules/BigCalendar/BigCalendarInTimeZone.js